import { useMemo } from "react";

// Attn: Avoids name conflict with React Router's useSearchParams
// get's and removes query parameters from the URL
export default function useQueryParams({ keys, removeKeys }: { keys: string[], removeKeys?: string[] }) {
  return useMemo(() => {
    const url = new URL(window.location.href);
    const queryParameters = url.searchParams

    // not available after history change
    const returnKeys = keys.map(
      key => queryParameters.get(key)
    )

    if (removeKeys) {
      removeKeys.forEach(key => queryParameters.delete(key));

      // Update the URL without reloading the page
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }

    return returnKeys
  }, [])
}
